import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Grid from '@mui/material/Grid';
import { Button, IconButton } from '@material-ui/core';
import axios from 'axios';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import { Backdrop, CircularProgress } from "@mui/material";
import SelectAll from '@mui/icons-material/SelectAll'
import '../css/login.css'

const url = "https://nrbegzvavi.execute-api.us-east-1.amazonaws.com/dev/schedule/create";


const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '25ch',
        },
        width: '100%',
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
}));



function getSteps() {
    return ['Cambiar de Medico'];
}

function getStepContent(stepIndex, props, body) {

    switch (stepIndex) {

        case 0:
            return (<div>

                <Grid container className="container">

                    
                    <Grid item xs={12} sm={6} md={4}>
                    <TextField id="patient" label="Paciente" value={body.patient?.firstName ? body.patient?.firstName + " " + body.patient?.lastName: ''}  disabled={true}  display="inline"/>
                        <label htmlFor="icon-button-file">
                            <IconButton color="primary" aria-label="Selec Paciente" component="span" onClick={() => {
                                props.setComeFromMenu(false);
                                props.setReturnPageId(13);
                                props.changeMenu(3)
                            }}>
                                <SelectAll />
                            </IconButton>
                        </label>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                    <TextField id="medicalTeam" label="Medico" value={body.medicalTeam?.firstName ?body.medicalTeam?.firstName + " " + body.medicalTeam?.lastName: ''}  disabled={true}  display="inline"/>

                        <label htmlFor="icon-button-file">
                            <IconButton color="primary" aria-label="Selec Medico" component="span" onClick={() => {
                                props.setComeFromMenu(false);
                                props.changeMenu(4);
                            }}>
                                <SelectAll />
                            </IconButton>
                        </label>
                    </Grid>

                </Grid>

            </div>);

        default:
            return 'Unknown stepIndex';
    }
}


function AssignPatients(props) {
    const classes = useStyles();
    const [body, setBody] = useState({

        patient: props.affiliateInfo,
        medicalTeam: props.medical
    })

    const [activeStep, setActiveStep] = React.useState(0);
    const [openLoader, setOpenLoader] = React.useState(false);

    const steps = getSteps();


    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    return (
        <div>
            <Stepper activeStep={activeStep} alternativeLabel>
                {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>

            <div>{getStepContent(activeStep, props, body)}</div>


            <div>

                <div>
                    <Button
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        className={classes.backButton}>
                        Back
                    </Button>
                    <Button variant="contained" className="buttonNext"
                        color="primary" onClick={() => {

                            if (activeStep === steps.length - 1) {
                                setOpenLoader(true);
                                axios.post(url, body).then(response => {

                                    setOpenLoader(false);
                                    props.changeMenu(1);


                                });
                            } else {
                                handleNext();
                            }
                        }}>
                        {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                    </Button>
                </div>
            </div>


            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={openLoader}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
};

export default AssignPatients;